import { useEffect, useState } from "react";
import axios from "axios";
import { MessageCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function WhatsAppButton() {
  const [number, setNumber] = useState("");

  useEffect(() => {
    axios.get(`${API}/config`).then((r) => setNumber(r.data.whatsapp_number || "")).catch(() => {});
  }, []);

  if (!number) return null;
  const href = `https://wa.me/${number.replace(/[^0-9]/g, "")}?text=${encodeURIComponent("Hi Fairy Yasha, I'd love a reading ✦")}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      className="group fixed bottom-6 right-6 z-[60] flex items-center gap-3 rounded-full bg-gradient-to-r from-[#9C2A52] to-[#C77E8A] pl-4 pr-5 py-3.5 shadow-[0_0_30px_rgba(156,42,82,0.45)] transition-transform duration-300 hover:scale-105"
    >
      <MessageCircle className="w-5 h-5 text-[#EFE3CC]" strokeWidth={1.6} />
      <span className="text-xs tracking-[0.15em] uppercase text-[#EFE3CC] hidden sm:inline">Chat now</span>
    </a>
  );
}
